<template>
  <div class="pbar">
    <PBarPoint :active="step == 1" text="Рассчитайте стоимость полиса">1</PBarPoint>
    <div class="pbar__filler"></div>
    <PBarPoint :active="step == 2" text="Укажите ваши данные">2</PBarPoint>
    <div class="pbar__filler"></div>
    <PBarPoint :white="true" :active="step == 3" text="Мы вышлем полис на электронную почту сразу после оплаты">3</PBarPoint>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PBarPoint from './PBarPoint.vue';

export default {
  computed: {
    ...mapState(["step"])
  },
  components: { PBarPoint }
}
</script>

<style lang="sass" scoped>
.pbar
  display: flex
  align-items: center
  &__filler
    flex-grow: 1
    margin: 0 32px
    height: 1px
    background: colors.$moar_silver_for_the_god_of_silver
    border-radius: 2px
  @include from(820px)
    &__filler
      display: none
</style>